import { render, staticRenderFns } from "./commuInfoDet.vue?vue&type=template&id=271d3b30"
import script from "./commuInfoDet.vue?vue&type=script&lang=js"
export * from "./commuInfoDet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports